import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {RouterModule} from '@angular/router';
import {
    SubLayoutDefaultLoggedInContainerComponent
} from '@shop_allgaeu-brennerei_de/layout/default/layout-default-logged-in-container.component';
import {ReactiveFormsModule} from '@angular/forms';
import {BadgeModule} from "primeng/badge";
import {CustomerModule} from "@iw-shop/customer/customer.module";
import {UserModule} from "@iw-shop/user/user.module";
import {NewsModule} from "@iw-shop/news/news.module";
import {
    SubContainerUserCustomerComponent
} from "@shop_allgaeu-brennerei_de/layout/container-user-customer/sub-container-user-customer.component";
import {SubBlockInfoComponent} from "@shop_allgaeu-brennerei_de/layout/info-block/sub-block-info.component";
import {
    SubBlockRecommendationsComponent
} from "@shop_allgaeu-brennerei_de/layout/block-recommendations/sub-block-recommendations.component";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {CoreModule} from "@iw-shop/core/core.module";

@NgModule({
    declarations: [
        SubLayoutDefaultLoggedInContainerComponent,
        SubContainerUserCustomerComponent,
        SubBlockRecommendationsComponent
    ],
    exports: [
        SubLayoutDefaultLoggedInContainerComponent,
        SubContainerUserCustomerComponent,
        SubBlockInfoComponent,
        SubBlockRecommendationsComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        BadgeModule,
        CustomerModule,
        UserModule,
        NewsModule,
        NgOptimizedImage,
        FontAwesomeModule,
        CoreModule,
        SubBlockInfoComponent
    ]
})
export class SubLayoutModule {
}
